const getAccountId = () => {
  const match = window.location.pathname.match(
    /\/app\/accounts\/(\d+)/
  );

  return match?.[1] || null;
};

const getAxiosClient = () => {
  if (!window.axios) {
    throw new Error(
      'El cliente Axios configurado por Chatwoot no está disponible'
    );
  }

  return window.axios;
};

const getBaseURL = () => {
  const accountId = getAccountId();

  if (!accountId) {
    throw new Error('No se pudo determinar la cuenta activa');
  }

  return `/api/v1/accounts/${accountId}/smarttec/ai_control`;
};

const AIControlAPI = {
  getStatus() {
    return getAxiosClient().get(getBaseURL());
  },

  setManual(enabled) {
    return getAxiosClient().post(
      `${getBaseURL()}/manual`,
      { enabled }
    );
  },
};

export default AIControlAPI;
